import * as types from '../constants/actionTypes';
import objectAssign from 'object-assign';
import initialState from './initialState';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function menuReducer(state = initialState.bookmarks, action) {
  let newState;
  const bookmarks = [...state.bookmarks];
  switch (action.type) {
  case types.BOOKMARKS_LOADING:
    newState = objectAssign({}, state);
    newState.loading = true;
    newState.error = '';
    return newState;
  case types.BOOKMARKS_SUCCESS:
    newState = objectAssign({}, state);
    newState.loading = false;
    newState.error = '';
    newState.bookmarks = action.payload;
    return newState;
  case types.USERS_LOADING:
    newState = objectAssign({}, state);
    newState.loading = true;
    newState.error = '';
    return newState;
  case types.USERS_SUCCESS:
    newState = objectAssign({}, state);
    newState.loading = false;
    newState.error = '';
    newState.users = action.payload;
    return newState;
  case types.SAVE_BOOKMARK_REQUEST:
    newState = objectAssign({}, state);
    newState.loading = true;
    newState.error = '';
    return newState;
  case types.SAVE_BOOKMARK_SUCCESS:
    newState = objectAssign({}, state);
    newState.loading = false;
    newState.error = '';
    if (action.new) {
      bookmarks.push(action.payload);
    } else {
      const index = bookmarks.map(function(b) { return b.id; }).indexOf(action.payload.id);
      bookmarks[index] = action.payload;
    }
    newState.bookmarks = bookmarks;
    return newState;
  case types.DELETE_BOOKMARK_SUCCESS:
    newState = objectAssign({}, state);
    newState.loading = false;
    newState.error = '';
    bookmarks.splice(bookmarks.map(function(b) { return b.id; }).indexOf(action.id), 1);
    newState.bookmarks = bookmarks;
    return newState;
  case types.BOOKMARKS_FAILURE:
  case types.USERS_FAILURE:
  case types.SAVE_BOOKMARK_FAILURE:
  case types.DELETE_BOOKMARK_FAILURE:
    newState = objectAssign({}, state);
    newState.loading = false;
    newState.error = action.error;
    return newState;
  default:
    return state;
  }
}
